var _line, _path, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 27,
    viewBox: "0 0 348 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.498848,
    y1: 13.1719,
    x2: 150.498,
    y2: 12.8263,
    stroke: "#D6D6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.466 15.644C166.466 14.744 166.658 13.952 167.042 13.268C167.426 12.584 167.954 12.044 168.626 11.648C169.298 11.252 170.054 11.054 170.894 11.054C171.746 11.054 172.502 11.252 173.162 11.648C173.834 12.044 174.362 12.584 174.746 13.268C175.13 13.952 175.322 14.744 175.322 15.644C175.322 16.52 175.13 17.306 174.746 18.002C174.362 18.686 173.834 19.226 173.162 19.622C172.502 20.018 171.746 20.216 170.894 20.216C170.054 20.216 169.298 20.018 168.626 19.622C167.954 19.226 167.426 18.686 167.042 18.002C166.658 17.306 166.466 16.52 166.466 15.644ZM167.726 15.626C167.726 16.31 167.858 16.916 168.122 17.444C168.398 17.96 168.77 18.368 169.238 18.668C169.718 18.956 170.27 19.1 170.894 19.1C171.518 19.1 172.064 18.956 172.532 18.668C173.012 18.368 173.384 17.96 173.648 17.444C173.924 16.916 174.062 16.31 174.062 15.626C174.062 14.954 173.924 14.36 173.648 13.844C173.384 13.328 173.012 12.92 172.532 12.62C172.064 12.32 171.518 12.17 170.894 12.17C170.27 12.17 169.718 12.32 169.238 12.62C168.77 12.92 168.398 13.328 168.122 13.844C167.858 14.36 167.726 14.954 167.726 15.626ZM181.863 11.18V12.296H181.179C180.375 12.296 179.733 12.542 179.253 13.034C178.785 13.526 178.551 14.192 178.551 15.032V20H177.309V11.288H178.479L178.587 12.998H178.461C178.581 12.434 178.875 11.978 179.343 11.63C179.811 11.27 180.381 11.09 181.053 11.09C181.185 11.09 181.317 11.096 181.449 11.108C181.581 11.12 181.719 11.144 181.863 11.18Z",
    fill: "#D6D6D6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 197.499,
    y1: 13.1719,
    x2: 347.498,
    y2: 12.8263,
    stroke: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrIcon);
export default __webpack_public_path__ + "static/media/or_icon.a3d64bb50acf7e38f492c89da173621e.svg";
export { ForwardRef as ReactComponent };